howspace.automation = (() => {
    'use strict';

    const initActionSettings = collapse => {
        if (!collapse.data('editors-initialized')) {
            // Action templates defer text editors with this marker until their settings are first opened.
            collapse.find('.howspace-text-editor-initialized').removeClass('howspace-text-editor-initialized');
            collapse.data('editors-initialized', true);
        }
        howspace.components.init(collapse);
        howspace.components.textEditor.repaint(collapse);
    };

    const focusActionSetting = (collapse, field = '') => {
        let input = collapse.find('[name]').filter((_, elem) => elem.name === field);
        if (field === 'recipient_ids') {
            input = input.closest('.howspace-user-picker').find('[role="combobox"]');
        }
        if (input.filter(':visible').length > 0) {
            input.filter(':visible').first().trigger('focus');
        } else {
            howspace.form.focusFirstInput(collapse);
        }
    };

    const expandActionSettings = (action, field = '') => {
        const collapse = action.find('.action-params-collapse');
        if (collapse.hasClass('expanded')) {
            initActionSettings(collapse);
            focusActionSetting(collapse, field);
        } else {
            collapse.data('repair-field', field);
            howspace.components.collapse.expand(action.find('.edit-action-btn'));
        }
    };

    const enableSaveButton = modal => {
        let requiredInputs = modal.find('input[name="name"], .action-list .action-item [required], .frequency-select:visible').filter(function () {
            return $(this).closest('.trigger-arguments-collapse, .action-params-collapse').length === 0;
        });

        const selectedTriggerItem = modal.find('.trigger-item[aria-selected="true"]');
        const triggerArgsCollapse = selectedTriggerItem.find('.trigger-arguments-collapse');
        requiredInputs = requiredInputs.add(triggerArgsCollapse.find('input[required], select[required]'));

        modal.find('.action-list .action-item').each(function () {
            const action = $(this);
            requiredInputs = requiredInputs.add(action.find('input[required], select[required]'));
        });

        let disabled = false;
        if (selectedTriggerItem.length === 0) {
            disabled = true;
        }
        if (modal.find('.action-list .action-item').length === 0) {
            disabled = true;
        }
        requiredInputs.each(function () {
            const input = $(this);
            if (!input.val()) {
                disabled = true;
                return false;
            }
        });

        if (modal.find('.alert-warning:visible:not(.automation-configuration-notice)').length > 0) {
            disabled = true;
        }

        if (selectedTriggerItem.length && selectedTriggerItem.data('type') === 'scheduled') {
            const frequencyVal = modal.find('.frequency-select').val();
            if (!frequencyVal) {
                disabled = true;
            }
        }

        modal.find('.modal-footer .btn-success').prop('disabled', disabled);
    };

    const attachFormEvents = modal => {
        enableSaveButton(modal);

        // Without a saved date, "Only include new users" starts from the beginning of today in the admin's timezone.
        const addedAfterPicker = modal.find('.added-after-picker');
        if (addedAfterPicker.length && !addedAfterPicker.data('date')) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            howspace.components.datePicker.setDate(addedAfterPicker, today.toISOString());
        }

        modal.on('input', 'input[required]', () => {
            enableSaveButton(modal);
        });

        modal.on('input', 'select[required]:visible', () => {
            enableSaveButton(modal);
        });

        modal.on('click', '.delete-btn', e => {
            const card = $(e.currentTarget).closest('.action');
            howspace.components.collapse.collapse(card.find('.card-title'));
            enableSaveButton(modal);
        });

        modal.on('click', '.undelete-btn', () => {
            enableSaveButton(modal);
        });

        modal.on(howspace.components.collapse.EXPANDED, '.collapse', () => {
            enableSaveButton(modal);
        });

        modal.on('change', '.action-select', e => {
            const select = $(e.currentTarget);
            const card = select.closest('.card');
            const actions = card.closest('.actions');

            actions.find('.card-title.howspace-collapse-initialized').each(function () {
                howspace.components.collapse.collapse(this);
            });

            howspace.components.collapse.expand(card.find('.card-title'));

            card.find('.action-params-collapse.expanded').each(function () {
                howspace.components.collapse.close($(this));
            });

            const collapse = card.find('#action-params-' + select.val() + '-collapse');
            howspace.components.collapse.open(collapse);
        });

        modal.find('.param-select').on('change', e => {
            const collapse = $(e.currentTarget).closest('.collapse');
            howspace.animate(collapse.find('.param-alert:visible'), 'slideUp');
            enableSaveButton(modal);
        });

        modal.find('.frequency-select').on('change', () => {
            enableSaveButton(modal);
        });

        modal.find('.actions').on(howspace.components.sortableList.ITEM_MOVED, () => {
            let index = 1;
            modal.find('.action').each(function () {
                const action = $(this);
                const title = action.find('.card-title');
                title.html(title.html().trim().replace(/\d+$/, String(index)));
                index++;
            });
        });

        modal.find('.show-action-menu-btn').on('click', () => {
            modal.find('.action-menu').removeClass('d-none');
            modal.find('.action-list').addClass('d-none');
            modal.find('.show-action-menu-btn').attr('aria-expanded', 'true');
            modal.find('.actions-search-input').val('').trigger('input').trigger('focus');
        });

        modal.find('.hide-action-menu-btn').on('click', () => {
            modal.find('.action-menu').addClass('d-none');
            modal.find('.action-list').removeClass('d-none');
            modal.find('.show-action-menu-btn').attr('aria-expanded', 'false');
        });

        modal.find('.add-action-btn').on('click', e => {
            modal.find('.action-menu').addClass('d-none');
            modal.find('.action-list').removeClass('d-none');
            modal.find('.hide-action-menu-btn').removeClass('d-none');
            modal.find('.show-action-menu-btn').attr('aria-expanded', 'false');

            const btn = $(e.currentTarget);
            const action = btn.closest('.action-item');
            const newAction = action.clone();
            newAction.attr('aria-selected', 'true');
            newAction.find('.howspace-user-picker-initialized').removeClass('howspace-user-picker-initialized');
            newAction.find('.howspace-form-search-label-initialized').removeClass('howspace-form-search-label-initialized');
            newAction.find('.howspace-collapse-initialized').removeClass('howspace-collapse-initialized');
            newAction.find('[aria-controls]').each(function () {
                const control = $(this);
                const oldIds = control.attr('aria-controls').split(' ');
                const newIds = oldIds.map(oldId => {
                    const newId = oldId + '-' + real.uid();
                    newAction.find('#' + oldId).attr('id', newId);
                    return newId;
                });
                control.attr('aria-controls', newIds.join(' '));
            });
            newAction.find('.card').each(function () {
                howspace.components.card.setId($(this));
            });
            newAction.removeClass('add-action-btn');

            modal.find('.action-list .show-action-menu-btn').before(newAction);
            howspace.components.init(newAction);

            if (newAction.find('.action-params-collapse').length > 0) {
                expandActionSettings(newAction);
            }

            enableSaveButton(modal);
        });

        modal.find('input[name="target_anonymous_users"]').on('change', e => {
            const checkbox = $(e.currentTarget);
            if (checkbox.is(':checked')) {
                modal.find('input[name="roles"][value="participant"]').prop('checked', true);
                modal.find('input[name="roles"]').not('[value="participant"]')
                    .prop('disabled', true)
                    .closest('label').addClass('disabled');
            } else {
                modal.find('input[name="roles"]').prop('disabled', false)
                    .closest('label').removeClass('disabled');
            }
        });

        modal[0].addEventListener(howspace.components.tab.TAB_SHOWN, e => {
            const tab = e.detail.tab;
            const panelId = tab.attr('aria-controls');
            const tabPanel = modal.find('#' + panelId);

            if (panelId === 'tabpanel-actions') {
                tabPanel.find('.action-list .action-params-collapse.expanded').each(function () {
                    initActionSettings($(this));
                });
            }

            if (panelId === 'tabpanel-schedule') {
                updateScheduleSummary(modal);
            }

            if (panelId === 'tabpanel-review') {
                populateReviewTab(modal);
            }

            const previousBtn = modal.find('.previous-btn');
            const nextBtn = modal.find('.next-btn');
            const successBtn = modal.find('.btn-success');

            if (tab.prev('.howspace-tab').length === 0) {
                // first tab
                previousBtn.prop('disabled', true);
                nextBtn.prop('disabled', false);
                nextBtn.removeClass('d-none');
                successBtn.addClass('d-none');
            } else if (tab.next('.howspace-tab').length === 0) {
                // last tab
                previousBtn.prop('disabled', false);
                nextBtn.prop('disabled', true);
                nextBtn.addClass('d-none');
                successBtn.removeClass('d-none');
            } else {
                // in between
                previousBtn.prop('disabled', false);
                nextBtn.prop('disabled', false);
                nextBtn.removeClass('d-none');
                successBtn.addClass('d-none');
            }

            howspace.form.focusFirstInput(tabPanel);
        });

        modal.find('.previous-btn').on('click', () => {
            const selectedTab = modal.find('.howspace-tab[aria-selected="true"]');
            const previousTab = selectedTab.prev('.howspace-tab');

            previousTab.trigger('click');
        });

        modal.find('.next-btn').on('click', () => {
            const selectedTab = modal.find('.howspace-tab[aria-selected="true"]');
            const nextTab = selectedTab.next('.howspace-tab');

            nextTab.trigger('click');
        });

        modal.find('#tabpanel-trigger .howspace-form-search-input').on(howspace.components.searchInput.SEARCH, e => {
            const search = (e.detail.value || '').toLowerCase().trim();
            if (search) {
                modal.find('.trigger-item').each(function () {
                    const item = $(this);
                    if (item.data('keywords').indexOf(search) > -1) {
                        item.removeClass('d-none');
                    } else {
                        item.addClass('d-none');
                    }
                });
            } else {
                modal.find('.trigger-item').removeClass('d-none');
            }
        });

        modal.find('#tabpanel-actions .action-menu .howspace-form-search-input').on(howspace.components.searchInput.SEARCH, e => {
            const search = (e.detail.value || '').toLowerCase().trim();
            if (search) {
                modal.find('.action-item').each(function () {
                    const item = $(this);
                    if (item.data('keywords').indexOf(search) > -1) {
                        item.removeClass('d-none');
                    } else {
                        item.addClass('d-none');
                    }
                });
            } else {
                modal.find('.action-item').removeClass('d-none');
            }
        });

        const scheduleSelect = modal.find('#schedule-select');

        scheduleSelect.on('change', 'select', () => updateScheduleSummary(modal));

        modal.find('.trigger-item').on('click', e => {
            const trigger = $(e.currentTarget);
            modal.find('.trigger-item[aria-selected="true"]').attr('aria-selected', 'false');
            trigger.attr('aria-selected', 'true');
            modal.addClass('has-trigger');

            if (trigger.data('type') === 'scheduled') {
                howspace.form.enable(scheduleSelect);
                modal.find('input[name="run_limit"][value="true"]').prop('checked', true);
            } else {
                scheduleSelect.find('.frequency-select').val(null).trigger('change');
                howspace.form.disable(scheduleSelect);
                modal.find('input[name="run_limit"][value="false"]').prop('checked', true);
            }
            howspace.form.focusFirstInput(trigger);
            enableSaveButton(modal);
        });

        modal.find('.delete-trigger-btn').on('keydown', e => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
                $(e.currentTarget).trigger('click');
            }
        });

        modal.find('.trigger-item').on('keydown', e => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                $(e.currentTarget).trigger('click');
            }
        });

        modal.find('.delete-trigger-btn').on('click', e => {
            const selectedTrigger = modal.find('.trigger-item[aria-selected="true"]');
            selectedTrigger.attr('aria-selected', 'false');
            modal.removeClass('has-trigger');
            howspace.components.scheduleSelect.reset(scheduleSelect);
            howspace.form.disable(scheduleSelect);
            modal.find('input[name="run_limit"][value="false"]').prop('checked', true);
            modal.find('.trigger-search-input').val('').trigger('input').trigger('focus');
            e.stopPropagation();
        });

        modal.on(howspace.components.collapse.EXPANDED, '.action-params-collapse', e => {
            if (e.target !== e.currentTarget) {
                return;
            }
            const collapse = $(e.currentTarget);
            initActionSettings(collapse);
            focusActionSetting(collapse, collapse.data('repair-field'));
            collapse.removeData('repair-field');
        });

        modal.on(howspace.components.collapse.COLLAPSED, '.action-params-collapse', e => {
            if (e.target === e.currentTarget) {
                $(e.currentTarget).closest('.action-item').find('.edit-action-btn').trigger('focus');
            }
        });

        modal.on('click', '.repair-automation-action-btn', e => {
            const btn = $(e.currentTarget);
            const index = String(btn.data('action-index'));
            const action = modal.find('.action-list .action-item').filter((_, elem) =>
                elem.getAttribute('data-configuration-action-index') === index);
            if (action.length === 0) {
                return;
            }
            modal.find('.howspace-tab[aria-controls="tabpanel-actions"]').trigger('click');
            expandActionSettings(action, btn.data('action-field'));
        });

        modal.on('click', '.delete-action-btn', e => {
            const btn = $(e.currentTarget);
            const action = btn.closest('.action-item');
            const previousAction = action.prev('.action-item');
            howspace.components.destroy(action);
            const index = action.attr('data-configuration-action-index');
            modal.find('.automation-configuration-notice [data-configuration-action-index]').filter((_, elem) =>
                elem.getAttribute('data-configuration-action-index') === index).remove();
            if (modal.find('.automation-configuration-notice [data-configuration-action-index]').length === 0) {
                modal.find('.automation-configuration-notice').remove();
            }
            action.remove();

            enableSaveButton(modal);

            if (modal.find('.action-list .action-item').length === 0) {
                modal.find('.action-menu').removeClass('d-none');
                modal.find('.action-list').addClass('d-none');
                modal.find('.hide-action-menu-btn').addClass('d-none');
                modal.find('.show-action-menu-btn').trigger('focus');
                modal.find('.actions-search-input').val('').trigger('input').trigger('focus');
            } else if (previousAction.length) {
                previousAction.find('.edit-action-btn, .delete-action-btn').first().trigger('focus');
            } else {
                modal.find('.action-list .action-item').first().find('.edit-action-btn, .delete-action-btn').first().trigger('focus');
            }
            e.stopPropagation();
        });

        const repairActionIndex = modal.data('repair-action-index');
        if (Number.isInteger(repairActionIndex)) {
            modal.find('.repair-automation-action-btn').filter((_, elem) =>
                $(elem).data('action-index') === repairActionIndex).trigger('click');
        }
    };

    const showSavedAsPausedNotification = automationId => {
        const text = real.escapeHtml(howspace.translate('workspacesettings_automations_saved_as_paused'));
        const activateText = real.escapeHtml(howspace.translate('workspacesettings_automations_activate'));
        real.notification.show(`
            ${text}
            <button type="button" class="btn btn-tertiary ml-3 activate-automation-btn"
                    data-automation-id="${real.escapeHtml(automationId)}">
                ${activateText}
            </button>
        `, 'success');
    };

    const initCreateModal = (modal) => {
        modal = $(modal);

        attachFormEvents(modal);
        enableSaveButton(modal);
        howspace.form.focusFirstInput(modal);

        modal.find('.modal-footer .btn-success').on('click', e => {
            const btn = $(e.currentTarget);
            real.button.loading(btn, modal);

            const dataPayload = getModalPayload(modal);

            real.ajax.json(real.baseUri + '/api/automations', {
                type: 'POST',
                data: JSON.stringify(dataPayload),
                success: response => {
                    howspace.components.modal.close(modal);
                    howspace.components.lister.reload($('.automations-lister'));
                    showSavedAsPausedNotification(response.automation.id);
                },
                error: () => {
                    real.button.reset(btn, modal);
                }
            });
        });
    };

    const getModalPayload = (modal) => {
        const dataPayload = {
            ...real.form.getDataPayload(modal),
            ...real.form.getDataPayload(modal.find('.trigger-item[aria-selected="true"]'))
        };

        dataPayload.actions = [];

        modal.find('.action-list .action-item').each(function () {
            const action = $(this);
            const type = action.find('input[name="type"]').val();

            dataPayload.actions.push({
                type: type,
                params: real.form.getDataPayload(action.find('.action-params-collapse'))
            });
        });

        if (modal.find('[aria-controls="added-after-collapse"]').attr('aria-expanded') !== 'true') {
            dataPayload.target_users_added_after = null;
        }

        if (dataPayload.run_limit === undefined) {
            dataPayload.run_limit = true;
        }

        if (dataPayload.frequency === null) {
            dataPayload.frequency = '';
        }

        if (dataPayload.schedule === null) {
            dataPayload.schedule = '';
        }

        return dataPayload;
    };

    const weekdayNumbers = {sunday: 0, monday: 1, tuesday: 2, wednesday: 3, thursday: 4, friday: 5, saturday: 6};
    const monthNumbers = {
        january: 0, february: 1, march: 2, april: 3, may: 4, june: 5,
        july: 6, august: 7, september: 8, october: 9, november: 10, december: 11
    };

    // The summaries are UI copy, so their dates and names follow the UI language. Weekday and month names sit
    // mid-sentence, and Intl gives them the right casing for it.
    const getUiLanguage = () => (real.locale.getLanguage() || 'en').replace('-formal', '');

    const getWeekdayName = weekday => new Intl.DateTimeFormat(getUiLanguage(), {weekday: 'long', timeZone: 'UTC'})
        .format(new Date(Date.UTC(2024, 0, 7 + weekdayNumbers[weekday])));

    const getMonthName = month => new Intl.DateTimeFormat(getUiLanguage(), {month: 'long', timeZone: 'UTC'})
        .format(new Date(Date.UTC(2024, monthNumbers[month], 1)));

    // The next time the selected schedule comes up. Daily and weekly selections are in the browser timezone.
    // Monthly and annual schedules have no time, so they run from midnight UTC on the first matching weekday.
    const getNextRun = (frequency, weekday, month, time) => {
        const now = new Date();

        if (frequency === 'daily' || frequency === 'weekly') {
            const [hours, minutes] = time.split('.').map(Number);
            const next = new Date(now);
            next.setHours(hours, minutes, 0, 0);
            if (frequency === 'weekly') {
                next.setDate(next.getDate() + (weekdayNumbers[weekday] - next.getDay() + 7) % 7);
            }
            if (next <= now) {
                next.setDate(next.getDate() + (frequency === 'weekly' ? 7 : 1));
            }
            return next;
        }

        const firstWeekdayOf = (year, monthIndex) => {
            const first = new Date(Date.UTC(year, monthIndex, 1));
            first.setUTCDate(1 + (weekdayNumbers[weekday] - first.getUTCDay() + 7) % 7);
            return first;
        };

        if (frequency === 'monthly') {
            const next = firstWeekdayOf(now.getUTCFullYear(), now.getUTCMonth());
            return next > now ? next : firstWeekdayOf(now.getUTCFullYear(), now.getUTCMonth() + 1);
        }

        if (frequency === 'annually') {
            const next = firstWeekdayOf(now.getUTCFullYear(), monthNumbers[month]);
            return next > now ? next : firstWeekdayOf(now.getUTCFullYear() + 1, monthNumbers[month]);
        }

        return null;
    };

    // A readable sentence for the selected schedule and its next run, e.g. "Runs every Monday at 09:00".
    const getScheduleSummary = scheduleSelect => {
        const frequency = scheduleSelect.find('.frequency-select').val();
        const weekday = scheduleSelect.find('.weekday-label select').val();
        const month = scheduleSelect.find('.month-label select').val();
        const timeSelect = scheduleSelect.find('.time-label select');
        const time = timeSelect.val();

        const params = {
            'time': real.escapeHtml(timeSelect.find('option:selected').text().trim()),
            'weekday': weekday in weekdayNumbers ? real.escapeHtml(getWeekdayName(weekday)) : '',
            'month': month in monthNumbers ? real.escapeHtml(getMonthName(month)) : ''
        };
        const summaries = {
            daily: () => howspace.translate('workspacesettings_automations_schedule_summary_daily', params),
            weekly: () => howspace.translate('workspacesettings_automations_schedule_summary_weekly', params),
            monthly: () => howspace.translate('workspacesettings_automations_schedule_summary_monthly', params),
            annually: () => howspace.translate('workspacesettings_automations_schedule_summary_annually', params)
        };
        const hasTime = frequency === 'daily' || frequency === 'weekly';
        // In half-hour timezones the time selector can be empty: its options are whole hours, so a stored UTC
        // time like 06:00 has no matching browser-time option
        if (!summaries[frequency] || (hasTime && !time)) {
            return '';
        }
        const summary = summaries[frequency]();

        // Time-less schedules run from midnight UTC, so their date is shown in UTC. The time is taken from the
        // selector so the summary and the selector show it the same way.
        const nextRun = getNextRun(frequency, weekday, month, time);
        let nextRunText = new Intl.DateTimeFormat(getUiLanguage(), {
            weekday: 'short',
            day: 'numeric',
            month: 'short',
            ...(hasTime ? {} : {timeZone: 'UTC'})
        }).format(nextRun);
        if (hasTime) {
            nextRunText += ', ' + timeSelect.find('option:selected').text().trim();
        }

        return summary + '. ' + howspace.translate('workspacesettings_automations_schedule_next_run', {'date': real.escapeHtml(nextRunText)});
    };

    const updateScheduleSummary = modal => {
        const summary = getScheduleSummary(modal.find('#schedule-select'));
        modal.find('.schedule-summary').html(summary).toggleClass('d-none', !summary);
    };

    const populateReviewTab = modal => {
        const reviewPanel = modal.find('#tabpanel-review');

        // Trigger summary
        const selectedTrigger = modal.find('.trigger-item[aria-selected="true"]');
        const triggerAlert = reviewPanel.find('.trigger-alert .alert-content');
        if (selectedTrigger.length) {
            const triggerName = selectedTrigger.find('.title').text().trim();
            triggerAlert.html('<strong>' + real.escapeHtml(triggerName) + '</strong>');
        } else {
            triggerAlert.html('<em>' + howspace.translate('workspacesettings_automations_review_no_trigger') + '</em>');
        }

        // Schedule summary
        const scheduleAlert = reviewPanel.find('.schedule-alert .alert-content');
        const scheduleLines = [];
        const scheduleSummary = getScheduleSummary(modal.find('#schedule-select'));
        if (scheduleSummary) {
            scheduleLines.push(scheduleSummary);
        } else if (selectedTrigger.data('type') === 'scheduled' || !selectedTrigger.length) {
            scheduleLines.push('<em>' + howspace.translate('workspacesettings_automations_review_no_schedule') + '</em>');
        }
        const runLimit = modal.find('input[name="run_limit"]:checked').val();
        scheduleLines.push(runLimit === 'true'
            ? howspace.translate('workspacesettings_automations_review_run_once_per_user')
            : howspace.translate('workspacesettings_automations_review_run_unlimited'));
        scheduleAlert.html(scheduleLines.join('<br>'));

        // Actions summary
        const actionsAlert = reviewPanel.find('.actions-alert .alert-content');
        const actionItems = modal.find('.action-list .action-item');
        if (actionItems.length) {
            const actionNames = [];
            actionItems.each(function () {
                const name = $(this).find('.title').text().trim();
                if (name) {
                    actionNames.push(real.escapeHtml(name));
                }
            });
            actionsAlert.html(actionNames.join(', '));
        } else {
            actionsAlert.html('<em>' + howspace.translate('workspacesettings_automations_review_no_actions') + '</em>');
        }

        // Audience summary, read as one sentence: the role first, then the filters that narrow it down.
        const audienceAlert = reviewPanel.find('.audience-alert .alert-content');
        const rolesChecked = modal.find('input[name="roles"]:checked');
        const roleText = rolesChecked.length ? real.escapeHtml(rolesChecked.closest('label').text().trim()) : '';
        const conditions = [];

        // Only new users
        const addedAfterToggle = modal.find('[aria-controls="added-after-collapse"]');
        const addedAfter = modal.find('.added-after-picker').data('date');
        if (addedAfterToggle.attr('aria-expanded') === 'true' && addedAfter) {
            const date = new Intl.DateTimeFormat(getUiLanguage(), {dateStyle: 'medium'}).format(new Date(addedAfter));
            conditions.push(howspace.translate('workspacesettings_automations_review_audience_added_after', {'date': real.escapeHtml(date)}));
        }

        // Last seen
        const lastSeenToggle = modal.find('[aria-controls="last-seen-collapse"]');
        if (lastSeenToggle.length && lastSeenToggle.attr('aria-expanded') === 'true') {
            const lastSeenCollapse = modal.find('#last-seen-collapse');
            if (lastSeenCollapse.find('#target-not-visited-days-radio:checked').length) {
                const days = real.escapeHtml(lastSeenCollapse.find('#target-not-visited-days-input').val());
                conditions.push(howspace.translate('workspacesettings_automations_review_audience_have_not_visited', {'days': days}));
            }
            if (lastSeenCollapse.find('#target-visited-days-radio:checked').length) {
                const days = real.escapeHtml(lastSeenCollapse.find('#target-visited-days-input').val());
                conditions.push(howspace.translate('workspacesettings_automations_review_audience_have_visited', {'days': days}));
            }
        }

        // User lists
        const userlistToggle = modal.find('[aria-controls="userlist-collapse"]');
        if (userlistToggle.length && userlistToggle.attr('aria-expanded') === 'true') {
            const listNames = [];
            modal.find('#userlist-collapse input:checked').each(function () {
                const name = $(this).next('.howspace-form-label-text').text().trim();
                if (name) {
                    listNames.push('<em>' + real.escapeHtml(name) + '</em>');
                }
            });
            if (listNames.length === 1) {
                conditions.push(howspace.translate('workspacesettings_automations_review_audience_userlist', {'userlist': listNames[0]}));
            } else if (listNames.length > 1) {
                conditions.push(howspace.translate('workspacesettings_automations_review_audience_userlists', {'userlists': listNames.join(', ')}));
            }
        }

        if (modal.find('input[name="target_anonymous_users"]').is(':checked')) {
            conditions.push(howspace.translate('workspacesettings_automations_review_audience_anonymous_users'));
        }

        let audienceText = roleText;
        if (roleText && conditions.length) {
            audienceText = howspace.translate('workspacesettings_automations_review_audience_sentence', {
                'roles': roleText,
                'conditions': conditions.join(' ' + howspace.translate('workspacesettings_automations_review_audience_and') + ' ')
            });
        }

        audienceAlert.html(audienceText || '<em>' + howspace.translate('workspacesettings_automations_review_no_audience') + '</em>');
    };

    return {
        initCreateModal: initCreateModal,
        attachFormEvents: attachFormEvents,
        getModalPayload: getModalPayload
    }
})();
